import React, { memo, useEffect } from 'react';
import betslip from '@gin-betting/betslip';
import core, { GQL } from '@gin-betting/core';
import { createSelector } from 'reselect';

import { useMemoSelector } from 'hooks';

const {
    appServiceLocator,
    hooks: { useDeepMemo },
    utils: { getIdsFromBetslipOddId },
} = core;

const {
    selectors: { selectInitialBetslipBet, selectBetslipOdds },
} = betslip;

const SynchronizeBetslipState: React.FC = () => {
    const variables = useDeepMemo(useMemoSelector(selectSyncBetslipVariables));

    useEffect(() => {
        if (!variables) return;

        appServiceLocator
            .get('apiClient')
            .makeRequest({
                method: 'changeGamblerBettingSlip',
                variables,
            })
            .catch(error => {
                console.error(error);
            });
    }, [variables]);

    return null;
};

const selectSyncBetslipVariables = createSelector(
    selectInitialBetslipBet,
    selectBetslipOdds,
    (
        betslipBet,
        betOdds
    ): GQL.ChangeGamblerBettingSlipMutationVariables | null => {
        if (!betslipBet) return null;

        const { mode: betType, stake, systemSize, betslipOddIds } = betslipBet;

        const isSingle = betType === GQL.BetType.SINGLE;

        const oddPaths: GQL.OddPath[] = betslipOddIds
            .map(bId => betOdds.get(bId))
            .filter((odd): odd is NonNullable<typeof odd> => !!odd)
            .map(({ id, singleStake }) => ({
                path: getIdsFromBetslipOddId(id).oddId,
                stake: isSingle ? singleStake : '',
            }))
            .toArray();

        const result: GQL.ChangeGamblerBettingSlipMutationVariables = {
            betType,
            oddPaths,
            systemSize,
        };

        if (!isSingle) {
            result.stake = stake;
        }

        return result;
    }
);

export default memo(SynchronizeBetslipState);
